module.exports = __webpack_public_path__ + "img/me.c0578678.png";